export const stateName = 'bank-account';